// src/services/AxiosInstance.js
import axios from "axios";

// IMPORTANT: if you import these helpers from slices elsewhere, remove duplicates.
// Keeping standalone here so this file works alone.

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || "https://pragathiapp.in",
  withCredentials: true,
});

const safeJson = (v, fallback) => {
  try {
    return JSON.parse(v);
  } catch {
    return fallback;
  }
};

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const toNumArray = (arr) =>
  (Array.isArray(arr) ? arr : [])
    .map((x) => Number(x))
    .filter((n) => Number.isFinite(n) && n > 0);

// ✅ decide which calls need tenant headers
const isTenantScopedUrl = (url = "") => {
  const u = String(url || "");

  return (
    u.startsWith("/api/dashboard") ||
    u.startsWith("/api/houses") ||
    u.startsWith("/api/wards") ||
    u.startsWith("/api/agents") ||
    u.startsWith("/api/house-master") ||
    u.startsWith("/api/house-details") ||
    u.startsWith("/api/house-profile") ||

    // ✅ NEW - WATER CONNECTION
    u.startsWith("/api/house-connection") ||

    u.startsWith("/api/meter-types") ||
    u.startsWith("/api/water-bills") ||
    u.startsWith("/api/receipts") ||
    u.startsWith("/api/discounts") ||
    u.startsWith("/api/meter-reset") ||
    u.startsWith("/api/house-settings") ||
    u.startsWith("/api/house-tools") ||
    u.startsWith("/api/financial-years") ||
    u.startsWith("/api/settings") ||
    u.startsWith("/api/waterbill-settings") ||
    u.startsWith("/api/reports") ||
    u.startsWith("/api/usermaster") ||
    u.startsWith("/api/admin") ||
    u.startsWith("/api/income-expense") ||
    u.startsWith("/api/slrm-bills") ||
    u.startsWith("/api/slrm-types") ||

    // ✅ NEW - APPROVAL SETTINGS
    u.startsWith("/api/v1/house-approval-settings") ||

    // ✅ NEW - SMS GATEWAY
    u.startsWith("/api/v1/sms-gateway")
  );
};
api.interceptors.request.use((config) => {
  // ---------------------------
  // Auth header
  // ---------------------------
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // ---------------------------
  // Tenant headers (only for tenant scoped)
  // ---------------------------
  const url = config.url || "";
  if (!isTenantScopedUrl(url)) return config;

  const pan_id_active = toNum(localStorage.getItem("pan_id_active") || 0);
  const pan_ids = toNumArray(
    safeJson(localStorage.getItem("pan_ids") || "[]", [])
  );

  // ✅ SINGLE mode -> x-pan-id
  if (pan_id_active > 0) {
    config.headers["x-pan-id"] = String(pan_id_active);
    // optionally keep helper:
    // config.headers["x-pan-id-active"] = String(pan_id_active);
    return config;
  }

  // ✅ ALL mode -> x-pan-ids as comma string
  if (pan_ids.length > 1) {
    config.headers["x-pan-ids"] = pan_ids.join(","); // ✅ "1,2"
  }

  return config;
});

export default api;

// Helper only (optional)
export const isLogin = () => !!localStorage.getItem("token");
